import React, { useEffect } from 'react';
import cart from '../images/shopping-cart.png';
import user from '../images/user.png';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';

const CartPage = (logged_user) => {
  const [loggedInUser, setLoggedInUser] = React.useState(logged_user);
  const navigate = useNavigate();
  const [cartItems, setCartItems] = React.useState({ username: 'guest', items: [] });

  useEffect(() => {
    const username = Cookies.get('username');
    const cartItemsString = Cookies.get('cartItems');
    const items = cartItemsString ? JSON.parse(cartItemsString) : [];
    setCartItems({ username, items });
  }, []);

  const userIconPressed = () => navigate('/login');
  const cartIconPressed = () => navigate('/');

  const totalPrice = cartItems.items
    ? cartItems.items.reduce((acc, item) => acc + item.price * item.timesAdded, 0)
    : 0;

  // ------------------------------------
  // REMOVE ONE ITEM
  // ------------------------------------
  const handleRemoveOne = (itemName) => {
    const updated = [...cartItems.items];
    const index = updated.findIndex(item => item.name === itemName);

    if (index !== -1) {
      if (updated[index].timesAdded <= 1) {
        updated.splice(index, 1);
      } else {
        updated[index].timesAdded -= 1;
      }
    }

    Cookies.set("cartItems", JSON.stringify(updated));
    setCartItems(prev => ({ ...prev, items: updated }));
  };

  // ------------------------------------
  // ADD ONE ITEM
  // ------------------------------------
  const handleAddOne = (itemName) => {
    const updated = [...cartItems.items];
    const index = updated.findIndex(item => item.name === itemName);

    if (index !== -1) {
      updated[index].timesAdded += 1;
    }

    Cookies.set("cartItems", JSON.stringify(updated));
    setCartItems(prev => ({ ...prev, items: updated }));
  };

  // ------------------------------------
  // REMOVE ALL QUANTITY OF ITEM
  // ------------------------------------
  const handleRemoveAll = (itemName) => {
    const updated = cartItems.items.filter(item => item.name !== itemName);
    Cookies.set("cartItems", JSON.stringify(updated));
    setCartItems(prev => ({ ...prev, items: updated }));
  };

  // ------------------------------------
  // CLEAR ENTIRE CART
  // ------------------------------------
  const handleClearCart = () => {
    Cookies.set("cartItems", JSON.stringify([]));
    setCartItems(prev => ({ ...prev, items: [] }));
  };

  const handleProceedToPayment = () => {
    const formElements = document.querySelectorAll('.cart-form input[required], .cart-form textarea[required]');
    let isFormValid = true;

    formElements.forEach((element) => {
      if (!element.value.trim()) {
        isFormValid = false;
      }
    });

    if (isFormValid) {
      const cookieKeys = Object.keys(Cookies.get());
      cookieKeys.forEach(key => Cookies.remove(key));
      navigate('/payment', { state: { total: totalPrice.toFixed(2) } });
    } else {
      alert('Please fill in all required fields before proceeding.');
    }
  };

  const handlePaymentInAdvance = () => {
    const formElements = document.querySelectorAll('.cart-form input[required], .cart-form textarea[required]');
    let isFormValid = true;

    formElements.forEach((element) => {
      if (!element.value.trim()) {
        isFormValid = false;
      }
    });

    if (isFormValid) {
      alert('Thank you for choosing us!');
      const cookieKeys = Object.keys(Cookies.get());
      cookieKeys.forEach(key => Cookies.remove(key));
      navigate('/');
    } else {
      alert('Please fill in all required fields before proceeding.');
    }
  };

  return (
    <div className="cart-page">
      <header>
        <div className="header-icons">
          <div className="cart-icon">
            <img src={cart} alt="Cart" onClick={cartIconPressed} />
          </div>
          <div className="user-icon">
            <img src={user} alt="User" onClick={userIconPressed} />
          </div>
        </div>
        <h1>Your Cart</h1>
      </header>

      <div className="main-cont">
        <form className="cart-form">
          <div className="personal-info">
            <label htmlFor="name">Name: (First and Last)</label>
            <input type="text" id="name" name="name" required autoComplete='off' />

            <label htmlFor="email">Email:</label>
            <input type="email" id="email" name="email" required autoComplete='off' />

            <label htmlFor="address">Address:</label>
            <textarea id="address" name="address" rows="3" required autoComplete='off'></textarea>

            <label htmlFor="country">Country:</label>
            <input type="text" id="country" name="country" required autoComplete='off' />

            <label htmlFor="zip">ZIP Code:</label>
            <input type="number" id="zip" name="zipcode" required autoComplete='off' />
          </div>

          <hr className="separator" />

          <div className="payment-method">
            <p>Payment Methods:</p>
            <button type="button" onClick={handleProceedToPayment}>
              Proceed with PayPal or Credit
            </button>
            <button type="button" onClick={handlePaymentInAdvance}>
              Pay on Delivery
            </button>
          </div>
        </form>

        <div className="cart-preview">
          <h2>Cart Preview</h2>
          {cartItems.items && cartItems.items.length > 0 ? (
            <>
              <p>Total different products: {cartItems.items.length}</p>
              <ul>
                {cartItems.items.map((item, index) => (
                  <li key={index}>
                    <button
                      style={{ marginRight: '6px' }}
                      onClick={() => handleRemoveOne(item.name)}
                    >
                      -
                    </button>

                    <button
                      style={{ marginRight: '6px' }}
                      onClick={() => handleAddOne(item.name)}
                    >
                      +
                    </button>

                    <button
                      style={{ marginRight: '8px' }}
                      onClick={() => handleRemoveAll(item.name)}
                    >
                      Remove
                    </button>

                    {item.name} &nbsp;•&nbsp;
                    Qty: {item.timesAdded} &nbsp;•&nbsp;
                    Total: €{(item.price * item.timesAdded).toFixed(2)}
                  </li>
                ))}
              </ul>

              <p style={{ marginTop: '15px', fontWeight: 'bold' }}>
                Total Price: €{totalPrice.toFixed(2)}
              </p>

              <button
                style={{ marginTop: '12px' }}
                onClick={handleClearCart}
              >
                Clear Cart
              </button>
            </>
          ) : (
            <p>No items added to the cart</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default CartPage;
